<template>
    <ControlButton v-if="isFullScreen" @click="setFullScreen(false)" iconClass="sr-2 sr-v2-collapse" />
    <ControlButton v-else @click="reallySetFullScreen()" iconClass="sr-2 sr-v2-expand" />
</template>

<script>
    import ControlButton from './ControlButton'
    import { mapActions, mapState } from '@/utils/namespaced-mappings'
    import fullScreenEmitter from '@/utils/fullScreenEmitter';

    export default {
        props: {
            namespace: { type: String, required: true },
        },

        components: {
            ControlButton
        },

        computed: {
            ...mapState(['isFullScreen'])
        },

        methods: {
            ...mapActions(['setFullScreen']),

            reallySetFullScreen() {
                fullScreenEmitter.fire()
                this.setFullScreen(true)
            }
        }
    }
</script>
